import { render, staticRenderFns } from "./draftList.vue?vue&type=template&id=cd382e80&scoped=true"
import script from "./draftList.vue?vue&type=script&lang=js"
export * from "./draftList.vue?vue&type=script&lang=js"
import style0 from "./draftList.vue?vue&type=style&index=0&id=cd382e80&prod&scoped=true&lang=scss"
import style1 from "./draftList.vue?vue&type=style&index=1&id=cd382e80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd382e80",
  null
  
)

export default component.exports